import { rollbar } from "../../rollbar";
export function sessionStorageGet(key: string): string | null | false {
  try {
    return sessionStorage.getItem(key);
  } catch (error) {
    rollbar?.error(error as Error, {
      context: "sessionStorage:sessionStorageGet",
    });
    return false;
  }
}

export function sessionStorageSet(key: string, value: string): void | false {
  try {
    sessionStorage.setItem(key, value);
  } catch (error) {
    rollbar?.error(error as Error, {
      context: "sessionStorage:sessionStorageSet",
    });
    return false;
  }
}
